module.exports = __webpack_public_path__ + "img/pennellata-horizontal.3ae65b20.jpg";